import { get, post } from '../request'

export const getProjects = (pagination) =>
  get('api/projects', {
    populate: ['estimate'],
    pagination,
  })
export const createProject = (params) => post('api/projects', params)
